import { useEffect, useState } from 'react';
import { getUserName } from '../Utils/GeneralUtils';
import { getMyTraining } from './trainingUtils';

/**
 * Whether training is open to the signed-in viewer: `null` while the read is
 * in flight, `false` on `enabled: false` or any failure. One `get_my_training`
 * read per signed-in trainer for the session, shared by every mount, since the
 * answer cannot change mid-session and the home page is opened all shift long.
 * A network error is forgotten so the next mount retries; a refusal is kept.
 */
const enabledByUser = new Map();

export const readTrainingEnabled = () => {
    const user = getUserName() || '';
    if (!enabledByUser.has(user)) {
        enabledByUser.set(
            user,
            getMyTraining()
                .then((data) => Boolean(data && typeof data === 'object' && data.enabled !== false))
                .catch((e) => {
                    if (e?.isNetwork) enabledByUser.delete(user);
                    return false;
                })
        );
    }
    return enabledByUser.get(user);
};

/** Test helper: forget every cached answer. */
export const resetTrainingEnabled = () => enabledByUser.clear();

export const useTrainingEnabled = () => {
    const [enabled, setEnabled] = useState(null);

    useEffect(() => {
        let active = true;
        readTrainingEnabled().then((value) => {
            if (active) setEnabled(value);
        });
        return () => {
            active = false;
        };
    }, []);

    return enabled;
};

export default useTrainingEnabled;
